export default __webpack_public_path__ + "static/media/InactiveReportVideo.12cbaa54.svg";